import { DashboardTypes, SwitchUserModeMutation, UserMode } from 'API';
import { API, button } from 'aws-amplify';
import { LoginComponent } from 'components/Aside/LoginComponent';
import { lightTheme } from 'components/style/Theme';
import { useLoggingActivity } from '../../customHooks/useLogging';

import APIContext from 'context/APIContext';
import AuthContext from 'context/AuthContext';
import { useCampaignContext } from 'context/CampaignContext';
import { useClientContext } from 'context/ClientContext';
import { switchUserMode } from 'graphql/mutations';
import { useContext, useMemo, useState } from 'react';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { ReactComponent as SVG_SETTINGS } from '../../assets/SVG/settings.svg';
import { ReactComponent as SVG_DIGITAL } from '../../assets/newAssets/Property 1=digital.svg';
import { ReactComponent as SVG_HOME } from '../../assets/newAssets/Property 1=home.svg';
import { ReactComponent as SVG_OOH_KAMPAGNE } from '../../assets/newAssets/Property 1=ooh.svg';
import { ReactComponent as SVG_PRINT } from '../../assets/newAssets/Property 1=print.svg';
import { ReactComponent as SVG_RADIO } from '../../assets/newAssets/Property 1=radio.svg';
import { ReactComponent as SVG_TV } from '../../assets/newAssets/Property 1=video.svg';
import { ReactComponent as SVG_CREATE } from '../../assets/newAssets/create.svg';
import { ReactComponent as SVG_PREVIEW } from '../../assets/newAssets/preview.svg';
import { AsideContainer, NavItem, Navigation } from './Aside.styles';
import { ReactComponent as SVG_FLOWCHART } from '../../assets/newAssets/Property 1=flowChart.svg';
import { ReactComponent as SVG_CINEMA } from '../../assets/SVG/cinema.svg';
// import { useEnrichedContext } from 'context/EnrichedContext';

import { iconList } from 'assets/newAssets/SVG/additionalIconsForLinks/iconList';
import InputContext from 'context/InputContext';
import { useVideoParams } from 'customHooks/useParameters';
import { checkIfPublished } from '../NewPortal/Main/Summary/ReportsLinks';

const { REACT_APP_LOGO } = process.env;

export const NavLink = styled(Link)`
  width: 3vw;
  height: 3vw;
  display: flex;
  flex-direction: column;
  justify-content: center; /* vertically aligns items */
  gap: 2px;
  text-decoration: none;
  font-size: 1vw;

  color: ${({ theme }) => theme.primaryGray};
  &:hover {
    cursor: pointer;
    color: ${({ theme }) => theme.c300};
    .svg {
      fill: ${({ theme }) => theme.c300};
    }
  }
`;

export const NavDiv = styled.div`
  width: 3vw;
  height: 3vw;
  display: flex;
  flex-direction: column;
  justify-content: center; /* vertically aligns items */
  gap: 2px;
  text-decoration: none;
  font-size: 1vw;

  color: ${({ theme }) => theme.primaryGray};
  &:hover {
    cursor: pointer;
    color: ${({ theme }) => theme.c300};
    .svg {
      fill: ${({ theme }) => theme.c300};
    }
  }
`;

export const SubMenu = styled.div`
  position: absolute;
  left: 100%;
  top: 0;
  background-color: ${({ theme }) => theme.background};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 7px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  min-width: 150px;
  z-index: 100;
  padding: 5px 0;

  a {
    padding: 8px 12px;
    width: auto;
    height: auto;
    display: flex;
    flex-direction: row !important;
    align-items: center;
    justify-content: flex-start;
    text-align: left;
    gap: 8px;

    &:hover {
      background-color: ${({ theme }) => theme.c100};
    }

    h4 {
      font-size: 11px;
      white-space: nowrap;
      margin: 0;
    }

    .submenu-icon {
      font-size: 14px;
      width: 16px;
      height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

const { REACT_APP_AGENCY_URL } = process.env;

export const http = {
  DEMO: 'https://nordics-demo.omd.com',
  STAGING: 'https://nordics-staging.annalect.com',
  PRODUCTION: `https://nordics.${REACT_APP_AGENCY_URL}.com`,
};

// Moved outside component to prevent re-creation on every render (causes flickering)
const LogoImage = ({ theme }: { theme: string }) => (
  <img
    style={{ width: '70%' }}
    className="bar__clientLogo"
    src={require(`../../assets/${theme}${REACT_APP_LOGO}`)}
    alt="Logo"
  />
);

type Props = {
  // dashType?: string;
  themeToggler: any;
  theme: any;
};

const Aside = (props: Props) => {
  const { checkPaddington, activeOrganization, anyPublish, anyCreate, isThereAnyReadPlus, setActiveOrganization } =
    useClientContext();
  const { activeCampaign, campaignList, setDashType, dashType, navigationCampaignList } = useCampaignContext();
  const isUserAuthorized = activeCampaign?.authorized;
  const memoizedCampaignList = useMemo(() => campaignList, [campaignList]);
  const memoizedActiveCampaign = useMemo(() => activeCampaign, [activeCampaign]);
  const { getEnvironment } = useContext(APIContext);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { userCanDoInsource } = useClientContext();
  const [, , deleteVideoSource] = useVideoParams();
  const logActivity = useLoggingActivity();
  const [adminToolsOpen, setAdminToolsOpen] = useState(false);

  const location = useLocation();
  const { user, userIsASolutionsArchitect } = useContext(AuthContext);
  // const { fullSources } = useEnrichedContext();

  async function changeMode(mode: string) {
    logActivity({
      action: 'SWITCH_USER_MODE',
    }).catch(console.error);

    try {
      const response = (await API.graphql({
        query: switchUserMode,
        variables: {
          Organization_id: activeOrganization?.OrganizationId,
          UserMode: UserMode[mode as keyof typeof UserMode],
          Environment: getEnvironment,
        },
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      })) as { data: SwitchUserModeMutation };

      //  response.data.switchUserMode?.StatusCode === 200 ? window.location.reload() : console.log("error")
      response.data.switchUserMode?.some((e) => e?.Status?.StatusCode === 200)
        ? window.location.reload()
        : console.log('error');
    } catch (e) {
      console.log(e);
    }
  }

  const redirectHome = () => {
    setDashType(DashboardTypes.HOME);
    setActiveOrganization(undefined);
  };

  const handleUserAdminClick = async () => {
    setDashType(DashboardTypes.HOME);

    try {
      const search = searchParams.toString();
      const targetUrl = `${window.location.origin}/reporting/userAdmin?${search}`;
      logActivity({
        action: 'USER_ADMIN',
        url: targetUrl,
      }).catch(console.error);
    } catch (error) {
      console.error('Failed to log user admin activity:', error);
    }
  };

  const dashboardTypeMap: { [key: string]: DashboardTypes } = {
    DIGITAL: DashboardTypes.DIGITAL,
    TV: DashboardTypes.TV /* || DashboardTypes.BVOD */,
    RADIO: DashboardTypes.RADIO,
    PRINT: DashboardTypes.PRINT,
    OOH: DashboardTypes.OOH,
    HOME: DashboardTypes.HOME,
    CINEMA: DashboardTypes.CINEMA,
    FLOWCHART: DashboardTypes.FLOWCHART,
    INSOURCE_DATA: DashboardTypes.INSOURCE_DATA,
    OVERWRITE: DashboardTypes.OVERWRITE,
  };

  const handleClick = async (link: string, dashboardType: string, subCampaigns: boolean) => {
    const search = searchParams.toString();
    console.log('SEARCH', search, dashboardType);

    // For Overview link, create special params that include client, campaignID (if present), and tab=summary (only if campaignID exists)
    let overviewParams = '';
    if (link === '/reporting/portal') {
      const clientParam = searchParams.get('client');
      const campaignId = searchParams.get('campaignID');

      const params = new URLSearchParams();
      if (clientParam) {
        params.set('client', clientParam);
      }
      if (campaignId) {
        params.set('campaignID', campaignId);
        params.set('tab', 'summary'); // Only add tab if campaignID exists
      }

      overviewParams = params.toString();
    }

    // Keep the old paramsClient for logging purposes
    const paramsClient = search.slice(0, search.indexOf('&') !== -1 ? search.indexOf('&') : search.length);
    console.log('PARAMS CLIENT', paramsClient);

    // Determine action based on link and dashboardType
    let action = 'DASHBOARD_CLICK'; // Default action
    if (link === '/reporting/portal') {
      action = 'CLIENT_OVERVIEW';
    } else if (link === '/reporting/dataOverwrite') {
      action = 'OVERWRITE_DATA';
    }

    // Log activity for navigation
    try {
      const targetUrl = `${window.location.origin}${link}?${link === '/reporting/portal' ? overviewParams : search}`;
      logActivity({
        action: action,
        url: targetUrl,
      }).catch(console.error);
    } catch (error) {
      console.error('Failed to log activity:', error);
    }

    if (dashboardType in dashboardTypeMap) {
      setDashType(dashboardTypeMap[dashboardType]);
    }
    // if (dashboardType !== 'TV') {
    //   deleteVideoSource();
    // }

    const searchParam = 'subcampaignID';
    const newSearchParams = new URLSearchParams(searchParams.toString());
    const childCampaignID = searchParams.get('childCampaignID');
    newSearchParams.delete('childCampaignID');
    if (dashboardType === DashboardTypes.TV || dashType === DashboardTypes.RADIO) {
      newSearchParams.delete('campaignPeriodID');
    }
    if (dashboardType !== DashboardTypes.TV) {
      newSearchParams.delete('videoSource');
    }

    if (subCampaigns === false) {
      newSearchParams.delete(searchParam);
      const finalSearch = newSearchParams.toString();

      if (dashboardType !== dashType) {
        navigate(link + '?' + (link === '/reporting/portal' ? overviewParams : finalSearch), {
          state: { client: paramsClient },
        });
      }
      // else {
      //   navigate(link + '?' + finalSearch);
      // }
    } else {
      newSearchParams.delete(searchParam);
      let finalSearch = newSearchParams.toString();

      if (dashboardType !== dashType) {
        navigate(link + '?' + finalSearch);
      }
    }
  };

  const hasDigital = activeCampaign?.dashboardType.some((e) => e === 'DIGITAL');
  const activeCampaignHasTVInternal = activeCampaign?.dashboardType.some((e) => e === 'TV' || e === 'BVOD');
  const activeCampaignHasRadioInternal = activeCampaign?.dashboardType.some((e) => e === 'RADIO');
  const activeCampaignHasPrintInternal = activeCampaign?.dashboardType.some((e) => e === 'PRINT');
  const activeCampaignHasOOHInternal = activeCampaign?.dashboardType.some((e) => e === 'OOH');
  const activeCampaignHasCinemaInternal = activeCampaign?.dashboardType.some((e) => e === 'CINEMA');
  const activeCampaignHasSearchInternal = activeCampaign?.dashboardType.some((e) => e === 'SEARCH');

  const campaignListHasDigitalInternal = navigationCampaignList?.some((e) =>
    e?.dashboardType.some((e) => e === 'DIGITAL'),
  );
  const campaignListHasTVInternal = navigationCampaignList?.some((e) =>
    e?.dashboardType.some((e) => e === 'TV' || e === 'BVOD'),
  );
  const campaignListHasRadioInternal = navigationCampaignList?.some((e) => e?.dashboardType.some((e) => e === 'RADIO'));
  const campaignListHasPrintInternal = navigationCampaignList?.some((e) => e?.dashboardType.some((e) => e === 'PRINT'));
  const campaignListHasOOHInternal = navigationCampaignList?.some((e) => e?.dashboardType.some((e) => e === 'OOH'));
  const campaignListHasCinemaInternal = navigationCampaignList?.some((e) =>
    e?.dashboardType.some((e) => e === 'CINEMA'),
  );
  const campaignListHasSearchInternal = navigationCampaignList?.some((e) =>
    e?.dashboardType.some((e) => e === 'SEARCH'),
  );
  // const userAccess = user?.signInUserSession.idToken?.payload['custom:access_level'] === 'ADMIN' || 'WRITE';

  const creatorIcon = iconList.find((icon) => icon === 'screen_share');
  const handymanIcon = iconList.find((icon) => icon === 'handyman');
  const MediaLink = (dashboard: DashboardTypes) => {
    const lookup = {
      DIGITAL: {
        link: '/reporting/onlinePortal',
        icon: () => {
          return <SVG_DIGITAL className="svg" />;
        },
        title: 'Digital',
        subCampaigns: false,
      },
      TV: {
        link: '/reporting/TVPortal',
        icon: () => {
          return <SVG_TV className="svg" />;
        },
        title: 'Video',
        subCampaigns: true,
      },
      RADIO: {
        link: '/reporting/radioPortal',
        icon: () => {
          return <SVG_RADIO className="svg" />;
        },
        title: 'Audio',
        subCampaigns: true,
      },
      PRINT: {
        link: '/reporting/printPortal',
        icon: () => {
          return <SVG_PRINT className="svg" />;
        },
        title: 'Print',
        subCampaigns: false,
      },
      OOH: {
        link: '/reporting/OOHPortal',
        icon: () => {
          return <SVG_OOH_KAMPAGNE className="svg" />;
        },
        title: 'Out of Home',
        subCampaigns: false,
      },
      HOME: {
        link: '/',
        icon: () => {
          return <SVG_HOME className="svg" />;
        },
        title: 'Home',
        subCampaigns: false,
      },
      FLOWCHART: {
        link: '/reporting/portal',
        icon: () => {
          return <SVG_FLOWCHART className="svg" />;
        },
        title: 'Overview',
        subCampaigns: false,
      },
      CINEMA: {
        link: '/reporting/cinemaPortal',
        icon: () => {
          return <SVG_CINEMA className="svg" />;
        },
        title: 'Cinema',
        subCampaigns: false,
      },
      BVOD: {
        link: '/reporting/BVODPortal',
        icon: () => {
          return <SVG_CINEMA className="svg" />;
        },
        title: 'BVOD',
        subCampaigns: false,
      },
      INSOURCE_DATA: {
        link: '/reporting/insourceDataPortal',
        title: 'Insource data',
        icon: () => {
          return (
            <div style={{ fontSize: '1vw' }} className="svg material-symbols-outlined  ">
              {creatorIcon}
            </div>
          );
        },

        subCampaigns: false,
      },
      OVERWRITE: {
        link: '/reporting/dataOverwrite',
        icon: () => {
          return (
            <div style={{ fontSize: '1vw' }} className="svg material-symbols-outlined">
              {handymanIcon}
            </div>
          );
        },
        title: 'Overwrite Data',
        subCampaigns: true,
      },

      SEARCH: {
        link: '/reporting/searchPortal',
        icon: () => {
          return (
            <div style={{ fontSize: '1vw' }} className="svg material-symbols-outlined">
              ads_click
            </div>
          );
        },
        title: 'Paid Search',
        subCampaigns: true,
      },

      // empty: {
      //   link: '/reporting/BVODPortal',
      //   icon: () => {
      //     return <SVG_CINEMA className="svg" />;
      //   },
      //   title: 'BVOD',
      //   subCampaigns: false,
      // },
    };

    const { link, icon, title, subCampaigns } = lookup[dashboard];

    return (
      <NavDiv
        onClick={() => handleClick(link, dashboard, subCampaigns)}
        className={dashType === dashboard ? 'selected ' : 'null'}
      >
        {icon()}
        <h4 className="navigationTitle">{title}</h4>
      </NavDiv>
    );
  };

  return (
    <>
      {dashType !== null && (
        <>
          <AsideContainer dashType={dashType}>
            <div className="logodiv" onClick={() => redirectHome()}>
              <NavLink to="/">
                <div className="logo">
                  {dashType !== DashboardTypes.HOME &&
                  window.localStorage.getItem('myTheme') === JSON.stringify(lightTheme) ? (
                    <LogoImage theme="light" />
                  ) : (
                    <LogoImage theme="dark" />
                  )}
                </div>
              </NavLink>
            </div>

            <Navigation dashType={dashType}>
              {dashType !== DashboardTypes.HOME && (
                <div>
                  {/* <NavLink className={location.pathname === '/reporting' ? 'selected' : 'null'} to="/">
              <div onClick={() => redirectHome()}>
                <SVG_HOME className="svg" />
                <h4 className="navigationTitle">Home</h4>
              </div>      
            </NavLink> */}

                  {memoizedCampaignList && (
                    <>
                      {memoizedActiveCampaign ? (
                        <>
                          {(anyPublish || isThereAnyReadPlus) && MediaLink(DashboardTypes.FLOWCHART)}
                          {/* {userAccess && MediaLink(DashboardTypes.FLOWCHART)} */}
                          {(isUserAuthorized
                            ? hasDigital
                            : hasDigital && checkIfPublished('Digital', activeCampaign)) &&
                            MediaLink(DashboardTypes.DIGITAL)}
                          {(isUserAuthorized
                            ? activeCampaignHasTVInternal
                            : activeCampaignHasTVInternal && checkIfPublished('Video', activeCampaign)) &&
                            MediaLink(DashboardTypes.TV)}
                          {(isUserAuthorized
                            ? activeCampaignHasRadioInternal
                            : activeCampaignHasRadioInternal && checkIfPublished('Audio', activeCampaign)) &&
                            MediaLink(DashboardTypes.RADIO)}
                          {(isUserAuthorized
                            ? activeCampaignHasPrintInternal
                            : activeCampaignHasPrintInternal && checkIfPublished('Print', activeCampaign)) &&
                            MediaLink(DashboardTypes.PRINT)}
                          {(isUserAuthorized
                            ? activeCampaignHasOOHInternal
                            : activeCampaignHasOOHInternal && checkIfPublished('OOH', activeCampaign)) &&
                            MediaLink(DashboardTypes.OOH)}
                          {(isUserAuthorized
                            ? activeCampaignHasCinemaInternal
                            : activeCampaignHasCinemaInternal && checkIfPublished('Cinema', activeCampaign)) &&
                            MediaLink(DashboardTypes.CINEMA)}
                          {hasDigital && userCanDoInsource && MediaLink(DashboardTypes.INSOURCE_DATA)}
                          {(isUserAuthorized
                            ? activeCampaignHasSearchInternal
                            : activeCampaignHasSearchInternal && checkIfPublished('Search', activeCampaign)) &&
                            MediaLink(DashboardTypes.SEARCH)}
                        </>
                      ) : (
                        <>
                          {(anyPublish || isThereAnyReadPlus) && MediaLink(DashboardTypes.FLOWCHART)}
                          {/* {userAccess && MediaLink(DashboardTypes.FLOWCHART)} */}
                          {campaignListHasDigitalInternal && MediaLink(DashboardTypes.DIGITAL)}
                          {campaignListHasSearchInternal && MediaLink(DashboardTypes.SEARCH)}
                          {campaignListHasTVInternal && MediaLink(DashboardTypes.TV)}
                          {campaignListHasRadioInternal && MediaLink(DashboardTypes.RADIO)}
                          {campaignListHasPrintInternal && MediaLink(DashboardTypes.PRINT)}
                          {campaignListHasOOHInternal && MediaLink(DashboardTypes.OOH)}
                          {campaignListHasCinemaInternal && MediaLink(DashboardTypes.CINEMA)}
                          {campaignListHasDigitalInternal &&
                            userCanDoInsource &&
                            MediaLink(DashboardTypes.INSOURCE_DATA)}
                        </>
                      )}
                    </>
                  )}
                  {checkPaddington && (
                    <div
                      style={{ position: 'relative' }}
                      onMouseEnter={() => setAdminToolsOpen(true)}
                      onMouseLeave={() => setAdminToolsOpen(false)}
                    >
                      <NavDiv
                        className={
                          adminToolsOpen ||
                          location.pathname === '/reporting/userAdmin' ||
                          location.pathname === '/reporting/dataOverwrite' ||
                          location.pathname === '/reporting/mappingOverview'
                            ? 'selected'
                            : 'null'
                        }
                      >
                        <SVG_SETTINGS className="svg" />
                        <h4 className="navigationTitle">Admin Tools</h4>
                      </NavDiv>

                      {adminToolsOpen && (
                        <SubMenu>
                          <NavLink
                            to={`/reporting/userAdmin?${searchParams.toString()}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => {
                              handleUserAdminClick();
                              setAdminToolsOpen(false);
                            }}
                            className={location.pathname === '/reporting/userAdmin' ? 'selected' : 'null'}
                          >
                            <span className="submenu-icon material-symbols-outlined">group</span>
                            <h4>User Admin</h4>
                          </NavLink>

                          {((memoizedActiveCampaign && hasDigital) ||
                            (!memoizedActiveCampaign && campaignListHasDigitalInternal)) && (
                            <NavLink
                              to={`/reporting/dataOverwrite?${searchParams.toString()}`}
                              onClick={() => {
                                handleClick('/reporting/dataOverwrite', 'OVERWRITE', true);
                                setAdminToolsOpen(false);
                              }}
                              className={location.pathname === '/reporting/dataOverwrite' ? 'selected' : 'null'}
                            >
                              <span className="submenu-icon material-symbols-outlined">edit_note</span>
                              <h4>Overwrite Data</h4>
                            </NavLink>
                          )}

                          {userIsASolutionsArchitect && (
                            <NavLink
                              to={`https://nordics-staging.annalect.com/mappingOverview?client=${encodeURIComponent(searchParams.get('client') || '')}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={() => {
                                // setDashType(DashboardTypes.HOME);
                                setAdminToolsOpen(false);
                              }}
                              className={location.pathname === '/reporting/mappingOverview' ? 'selected' : 'null'}
                            >
                              <span className="submenu-icon material-symbols-outlined">account_tree</span>
                              <h4>Mapping Overview</h4>
                            </NavLink>
                          )}
                        </SubMenu>
                      )}
                    </div>
                  )}
                </div>
              )}

              <div className="bottomNav">
                {activeOrganization && anyPublish && (
                  <>
                    {anyCreate ? (
                      <NavItem onClick={() => changeMode('PRESENTATION')}>
                        <SVG_CREATE className="svg" />
                        <h4 className="navigationTitle">Preview Off</h4>
                      </NavItem>
                    ) : (
                      <NavItem onClick={() => changeMode('DEVELOP')}>
                        <SVG_PREVIEW className="svg green" />
                        <h4 className="navigationTitle green">Preview On</h4>
                      </NavItem>
                    )}
                  </>
                )}

                {user?.username === 'onewp_benjamin.bruun@annalect.com' && dashType !== DashboardTypes.HOME && (
                  <NavItem className="tog" onClick={() => props.themeToggler()}>
                    {window.localStorage.getItem('myTheme') === JSON.stringify(lightTheme) ? (
                      <h4 className="navigationTitle">Dark</h4>
                    ) : (
                      <h4 className="navigationTitle">Light</h4>
                    )}
                    <h4 className="navigationTitle">Benjamin</h4>
                  </NavItem>
                )}

                <LoginComponent wrapper={'noWrapper'}></LoginComponent>
                <section className="user">
                  <p>
                    {user?.signInUserSession.idToken?.payload?.name
                      ? (user?.signInUserSession.idToken?.payload?.name?.at(0) ?? '')
                      : ''}
                    {user?.signInUserSession.idToken?.payload?.family_name
                      ? (user?.signInUserSession.idToken?.payload?.family_name?.at(0) ?? '')
                      : ''}
                  </p>
                </section>
              </div>
            </Navigation>
          </AsideContainer>
        </>
      )}
    </>
  );
};

export default Aside;
